
import React, { useEffect } from 'react';
import Swal from 'sweetalert2'
import { Route, Switch, BrowserRouter, Redirect } from "react-router-dom";
import { useSelector } from 'react-redux'
import LoginUser from "../components/Login/LoginUser";
import Profile from '../components/User/Profile';
import RegisterUser from '../components/Register/RegisterUser';

import RecoverPassword from '../components/Recover/RecoverPassword';
import RecoverPasswordConfirm from '../components/Recover/RecoverPasswordConfirm';
import RegisterEmail from '../components/Register/RegisterEmail';
import RegisterCodeVerification from '../components/Register/RegisterCodeVerification';
import CardNotifications from '../containers/CardNotifications';

import RecoverPasswordCode from '../components/Recover/RecoverPasswordCode';

import Logout from '../components/User/Logout';


import FriendList from '../components/SocialConnect/FriendList';
import BlockedFriendList from '../components/SocialConnect/BlockedFriendList';
import ResetPassword from '../components/Recover/ResetPassword';
import FollowingList from '../components/SocialConnect/FollowingList';
import FollowersList from '../components/SocialConnect/FollowersList';

import Post from '../components/Posts/Post';

import ReloadData from '../containers/ReloadData';


import CertificateAccount from '../components/Certification/CertificateAccount';
import CertificateAccountData from '../components/Certification/CertificateAccountData';




import ContactRequests from '../components/SocialConnect/ContactRequests';



import Album from '../components/Albums/Album';
import ReportContent from '../components/Posts/ReportPost';


import SeeLimitsReportAdmin from '../admin/components/Reports/SeeLimitsReportAdmin';
import HomeAdmin from '../admin/components/HomeAdmin';
import ClassCertificateAdmin from '../admin/components/Certifications/ClassCertificateAdmin';
import CreateRoom from '../components/Rooms/CreateRoom';
import EditRoom from '../components/Rooms/EditRoom';
import SeeAllRooms from '../components/Rooms/SeeAllRooms';

import RootUser from '../components/User/RootUser';
import HomePost from '../components/User/HomePost';
import OilCounter from '../components/User/OilCounter';


import RootRoom from '../components/Rooms/RootRoom';
import ChatCategorieAdmin from '../admin/components/Categories/ChatCategorieAdmin';
import CommunityCategorieAdmin from '../admin/components/Categories/CommunityCategorieAdmin';

import PermissionAdmin from '../admin/components/Permissions/PermissionAdmin';
import PointPackageAdmin from '../admin/components/Marks/PointPackageAdmin';


import SeeRoomsBySearch from '../components/Rooms/SeeRoomsBySearch';
import ReportBaneAdmin from '../admin/components/Reports/ReportBaneAdmin';
import SeeMyPostReported from '../components/Posts/SeeMyPostReported';
import CertificateStateConceptAdmin from '../admin/components/Certifications/CertificateStateConceptAdmin';




import TypeCertificateAdmin from '../admin/components/Certifications/TypeCertificateAdmin';





import TypeManagerAdmin from '../admin/components/Permissions/TypeManagerAdmin';
import ReportCategorieAdmin from '../admin/components/Categories/ReportCategorieAdmin';
import AuthLimitAdmin from '../admin/components/Reports/AuthLimitAdmin';

import PermissionGlobalAdmin from '../admin/components/Permissions/PermissionGlobalAdmin';
import RolesAdmin from '../admin/components/Permissions/RolesAdmin';
import AdminUsers from '../admin/components/Permissions/AdminUsers';

import Messages from '../components/Rooms/Messages';



import PQRSAdmin from '../admin/components/PQRS/PQRSAdmin';
import ColorsReactionsAdmin from '../admin/components/Colors/ColorsReactionsAdmin';
import MyPost from '../components/User/MyPost';
import MySaved from '../components/User/MySaved';
import SeeMyChallenges from '../components/User/SeeMyChallenges';
import PaymentTest from '../components/Payment/PaymentTest'
import { PendingPayment } from '../components/Payment/PendingPayment';
import { FailedPayment } from '../components/Payment/FailedPayment';
import { SuccessPayment } from '../components/Payment/SuccessPayment';

import Albums from '../components/Albums/Albums';


import RankingUser from '../components/User/RankingUser';



import TermsAndConditions from '../components/TermsAndConditions/TermsAndConditions';
import Privacy from '../components/TermsAndConditions/Privacy';

import LoginExternalAcepTerms from '../components/Login/LoginExternalAcepTerms';
import CreateFranchisee from '../components/Franchisee/CreateFranchisee';
import CreateRepresentative from '../components/Representative/CreateRepresentative';
import ProfileFranchisee from '../components/Franchisee/ProfileFranchisee';
import InventoryRoot from '../admin/components/Inventory/InventoryRoot';
import { WareHouseList } from '../admin/components/Stock/Warehouse/WareHouseList';
import UpdateWarehouse from '../admin/components/Stock/Warehouse/UpdateWareHouse';
import { CreateWineryContainer } from '../admin/components/Stock/Winery/CreateWineryContainer';
import { WineryList } from '../admin/components/Stock/Winery/WineryList';
import UpdateWinery from '../admin/components/Stock/Winery/UpdateWinery';
import Zones from '../components/Zones/Zones';
import Zone from '../components/Zones/Zone';

import { CreateSubWineryContainer } from '../admin/components/Stock/SubWinery/CreateSubWineryContainer';
import { SubWineriesList } from '../admin/components/Stock/SubWinery/SubWineriesList';
import UpdateSubWinery from '../admin/components/Stock/SubWinery/UpdateSubWinery';
import WineryBatches from '../admin/components/Inventory/WineryBatches/WineryBatches';
import MarketPlace from '../components/MarketPlace/ShowCase/ShowCase';
import ShoppingBag from '../components/MarketPlace/ShoppingBag';
import CertificateUserAuthRequest from '../admin/components/Certifications/CertificateUserAuthRequest';
import ReportUserAdmin from '../admin/components/Reports/ReportUserAdmin';
import ReactionAdmin from '../admin/components/Reactions/Reactions';
import InventoryFranchisee from '../components/Inventory/InventoryEcoMaster';
import ProductsItemMenuHistory from '../admin/components/Inventory/ProductsItemMenuHistory';
import TobeFranchiseList from '../admin/components/Certifications/TobeFranchiseList';
import CertificateMenu from '../admin/components/Certifications/CertificateMenu';
import CertificateFranchiseAuthRequest from '../admin/components/Certifications/CertificateFranchiseAuthRequest';
import TobeRepresentativeList from '../admin/components/Certifications/TobeRepresentativeList';
import CertificateRepresentativeRequest from '../admin/components/Certifications/CertificateRepresentativeRequest';
import TransferHistory from '../admin/components/Inventory/transfer/TransferHistory';
import TransferDetaill from '../admin/components/Inventory/transfer/TransferDetaill';
import CreateTranferWithoutOrder from '../admin/components/Inventory/transfer/CreateTranferWithoutOrder';
import PendingOrders from '../admin/components/Inventory/transfer/PendingOrders';
import OrderDetaill from '../admin/components/Inventory/transfer/OrderDetaill';
import Transfers from '../admin/components/Inventory/transfer/Transfers';
import { WineryAdmin } from '../admin/components/Stock/Winery/WineryAdmin';
import { WarehouseAdmin } from '../admin/components/Stock/Warehouse/WareHouseAdmin';
import ProductsListById from '../admin/components/Inventory/ProductsListById';
import BatchesList from '../admin/components/Inventory/BatchesList';
import CreateWarehouseAccount from '../admin/components/Inventory/Warehause/CreateWarehouseAccount';
import Wineries from '../admin/containers/Wineries/Wineries/Wineries';
import InventoryOptions from '../components/Inventory/InventoryOptions';
import MarketPlacePoints from '../components/MarketPlace/MarketPlacePoints';
import EditUser from '../components/User/EditUser';
import MessageRooms from '../containers/ChatRooms/MessageRooms/MessageRooms';
import ListRooms from '../components/Rooms/ListRooms';
import RootOneRoom from '../components/Rooms/Room/RootOneRoom';
import Join from '../components/Rooms/Room/Join';
import RootAdminRoom from '../components/Rooms/Room/Admin/RootAdminRoom';
import AdminRoomMembers from '../components/Rooms/Room/Admin/AdminRoomMembers';
import AdminRequestRoom from '../components/Rooms/Room/Admin/AdminRequestRoom';
import AdminInviteRoom from '../components/Rooms/Room/Admin/AdminInviteRoom';
import ViewStream from '../components/Stream/ViewStream';
import AdminDeleteRoom from '../components/Rooms/Room/Admin/AdminDeleteRoom';
import AdminReportsRoom from '../components/Rooms/Room/Admin/AdminReportsRoom';
import ZonePost from '../components/Zones/ZonePost/ZonePost';
import ZoneMembers from '../components/Zones/ZoneMembers';
import { ZoneAdminRoot } from '../components/Zones/Admin/ZoneAdminRoot';
import AdminReportsZone from '../components/Zones/Admin/AdminReportsZone';
import AdminEditZone from '../components/Zones/Admin/AdminEditZone';
import Campaigns from '../components/SocialConnect/Campaigns';
import ShoppingBagPoins from '../components/MarketPlace/ShopingBag/ShoppingBagPoins';
import CreatePqrs from '../components/Pqrs/CreatePqrs';
import ProducsCreate from '../admin/components/Inventory/Products/ProducsCreate';
import ProductEdit from '../admin/components/Inventory/Products/ProductEdit';
import LoginAdmin from '../components/Login/LoginAdmin';
import MessagesAdmin from '../components/Rooms/MessagesAdmin';
import AdminCampaigns from '../admin/components/Campaigns/AdminCampaigns';
import MainCampaigns from '../admin/components/Campaigns/MainCampaigns';

import Presentations from '../admin/components/Inventory/Products/Presentations/Presentations';
import ProductList from '../admin/components/Inventory/Products/ProductList';
import PrincipalInventoryMenu from '../admin/components/Inventory/PrincipalInventoryMenu';
import InventoryLocationsMenu from '../admin/components/Inventory/InventoryLocations/InventoryLocationsMenu';
import InventoryLocationsList from '../admin/components/Inventory/InventoryLocations/InventoryLocationsList/InventoryLocationsList';
import ProductLocationsList from '../admin/components/Inventory/InventoryLocations/ProductLocationsList/ProductLocationsList';
import BatchesLocationsList from '../admin/components/Inventory/InventoryLocations/BatchesLocationsList/BatchesLocationsList';
import ProductsConsolidation from '../admin/components/Inventory/InventoryLocations/ProductsConsolidation/ProductsConsolidation';
import EditFranchisee from '../components/Franchisee/EditFranchisee';
import ManageCampaigns from '../admin/components/Campaigns/ManageCampaigns';
import ProductDetaill from '../components/MarketPlace/ProductDetaill/ProductDetaill';
import OilMenu from '../components/Oil/OilMenu';
import OilRegister from '../components/Oil/OilRegister'
import OilRecordEcoCEO from '../components/Oil/OilRecordEcoCEO'
import OilRecordEcoUser from '../components/Oil/OilRecordEcoUser'
import ZoneRequest from '../components/Zones/Admin/ZoneRequest';
import AdminInviteZone from '../components/Zones/Admin/AdminInviteZone';
import Purchaseslist from '../components/MarketPlace/Purchases/Purchaseslist';
import PurchasesDetail from '../components/MarketPlace/Purchases/PurchasesDetail';
import CategoriesList from '../admin/components/Inventory/Products/Categories/CategoriesList';
import CategoryDetaill from '../admin/components/Inventory/Products/Categories/CategoryDetaill';
import Devolutions from '../admin/components/Inventory/Devolutions/Devolutions';
import DevolutionsDetaill from '../admin/components/Inventory/Devolutions/DevolutionsDetaill';
import InventoryList from '../components/Inventory/InventoryList';
import CreateZoneView from '../admin/components/Zone/CreateZone';
import InventorySales from '../components/Inventory/InventorySales';
import InventoryListForSale from '../components/Inventory/InventoryListForSale';
import InventorySaleCart from '../components/Inventory/InventorySaleCart';
import InventorySaleDetaill from '../components/Inventory/InventorySaleDetaill';
import DevolutionByUserView from '../components/Inventory/Devolutions/DevolutionByUser';
import StoriesBarNew from '../components/Stories/StoriesBarNew';
import CampaignsList from '../components/SocialConnect/CampaignsList';
import EditAdminCampaigns from '../admin/components/Campaigns/EditAdminCampaigns';
import HowEcoTienda from '../components/HowEcoTienda/HowEcoTienda';

import CreateConsignment from '../admin/components/Inventory/Consignment/CreateConsignment';
import CartConsignment from '../admin/components/Inventory/Consignment/CartConsignment';
import Utility from '../components/Inventory/Reports/Utility';
import ReportByType from '../components/Inventory/Reports/ReportByType';
import CreateDevolition from '../admin/components/Inventory/Devolutions/CreateDevolition';
import ReportedContent from '../admin/components/Reports/ReportedContent';
import ReportedUsers from '../admin/components/Reports/ReportedUsers';
import AdminAddMember from '../components/Zones/Admin/AdminAddMember';
import CreateRole from '../admin/components/Roles/CreateRole';
import ListRoles from '../admin/components/Roles/ListRoles';
import EditRole from '../admin/components/Roles/EditRole';
import CreateAdmin from '../admin/components/AdminUsers/CreateAdmin';
import ListAdmin from '../admin/components/AdminUsers/ListAdmin';
import EditAdmin from '../admin/components/AdminUsers/EditAdmin';
import localStorage from '../utils/hooks/useLocalStorage';
import PostCampaigns from '../components/User/PostCampaigns';
import ListZones from '../admin/components/Zone/ListZones';

import CreateJob from '../admin/components/Jobs/CreateJob';
import LitsJobs from '../admin/components/Jobs/LitsJobs';
import EditJob from '../admin/components/Jobs/EditJob';
import ListAdvertising from '../admin/components/Advertising/ListAdvertising';
import EditAdvertising from '../admin/components/Advertising/EditAdvertising';
import CreateAdvertising from '../admin/components/Advertising/CreateAdvertising';
import CreateStream from '../components/Stream/CreateStream';
import ProfileFranchise from '../components/User/ProfileFranchise';
import TestError from '../components/Test/TestError';
import RanksAdmin from '../admin/components/RanksAdmin/RanksAdmin';
import ListStickersView from '../admin/components/Stickers/ListStickers';
import ListStickers from '../admin/components/Stickers/ListStickers';
import Seguidores from '../components/SocialConnect/Seguidores';
import SocialList from '../components/User/SocialList';
import TestFetch from '../components/Test/TestFetch';
import Actions from '../admin/components/Actions/Actions';
import { Chat } from '../components/Rooms/Chat/Chat';

const Router = () => {

    const { text, type, duration, timestamp } = useSelector(state => state.popUp)


    useEffect(() => {
        if (timestamp) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: duration
            })

            Toast.fire({
                icon: type,
                title: text,
            })
        }
    }, [timestamp])

    return (
        <BrowserRouter>
            <Switch>
                {routes.map((route, i) => (
                    <RouteWithSubRoutes key={i} {...route} />
                ))}
            </Switch>
        </BrowserRouter>
    )
}

export default Router


const routes = [


    { isPrivate: false, isExact: true, path: "/AceptTerms", component: LoginExternalAcepTerms },
    { isPrivate: false, isExact: true, path: "/RecoverPassword", component: RecoverPassword },

    { isPrivate: false, isExact: true, path: "/RecoverPasswordConfirm", component: RecoverPasswordConfirm },
    { isPrivate: false, isExact: true, path: "/RecoverPasswordCode", component: RecoverPasswordCode },
    { isPrivate: false, isExact: true, path: "/RegisterUser", component: RegisterUser },



    { isPrivate: false, isExact: true, path: "/RegisterCodeVerification", component: RegisterCodeVerification },





















    { isPrivate: true, isExact: true, path: "/CardNotifications", component: CardNotifications },


    { isPrivate: true, isExact: true, path: "/Logout", component: Logout },




















    { isPrivate: false, isExact: true, path: "/Login", component: LoginUser },
    { isPrivate: false, isExact: true, path: "/Admin/Login", component: LoginAdmin },

    {
        isPrivate: true, isExact: false, type: 'admin', path: "/Admin", component: HomeAdmin,
        routes: [


            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ActionAwardsAdmin", component: Actions },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ListStickers", component: ListStickers },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Admin/:adminID", component: EditAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/CreateAdmin", component: CreateAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ListAdmin", component: ListAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Role/:roleID", component: EditRole },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ListRoles", component: ListRoles },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/CreateRole", component: CreateRole },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ReportListAdmin", component: ReportedUsers },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ReportedContent", component: ReportedContent },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Messages", component: Messages },
            /*     { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ClassCertificateAdmin", component: ClassCertificateAdmin }, */

            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/CategorieAdmin", component: ChatCategorieAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/CommunityCategorieAdmin", component: CommunityCategorieAdmin },

            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/PermissionAdmin", component: PermissionAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/PermissionGlobalAdmin", component: PermissionGlobalAdmin },

            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/RolesAdmin", component: RolesAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/RanksAdmin", component: RanksAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/AdminUsers", component: AdminUsers },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/TypeManagerAdmin", component: TypeManagerAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/PointPackageAdmin", component: PointPackageAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/AuthLimitAdmin", component: AuthLimitAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/SeeLimitsReportAdmin", component: SeeLimitsReportAdmin },

            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ReportCategorieAdmin", component: ReportCategorieAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ReportBaneAdmin", component: ReportBaneAdmin },


            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ReportUserAdmin", component: ReportUserAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/CertificateStateConceptAdmin", component: CertificateStateConceptAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/CertificateUserAuthRequest/:idAuthRequest", component: CertificateUserAuthRequest },


            ,
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/CertificateMenu", component: CertificateMenu },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/TobeFranchiseList", component: TobeFranchiseList },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/CertificateFranchiseAuthRequest/:idAuthRequest", component: CertificateFranchiseAuthRequest },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/TobeRepresentativeList", component: TobeRepresentativeList },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/CertificateRepresentativeRequest/:idAuthRequest", component: CertificateRepresentativeRequest },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/MainCampaigns", component: MainCampaigns },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/AdminCampaigns", component: AdminCampaigns },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ManageCampaigns/", component: ManageCampaigns },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/EditAdminCampaigns/:idCampaign", component: EditAdminCampaigns },

            {
                isPrivate: true, isExact: false, type: 'admin', path: "/Admin/Inventory", component: InventoryRoot,
                routes: [

                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/PrincipalInventoryMenu", component: PrincipalInventoryMenu },


                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/InventoryLocationsMenu", component: InventoryLocationsMenu },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/InventoryLocationsList/:inventoryType(Winery|SubWinery|EcoCEO|EcoMaster|EcoTiendas)", component: InventoryLocationsList },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/ProductLocationsList/:inventoryType(Location|Entity)/:locationId/:locationName", component: ProductLocationsList },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/BatchesLocationsList/:inventoryType(Location|Entity)/:productId/:locationId/:locationName", component: BatchesLocationsList },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/ProductsConsolidation", component: ProductsConsolidation },

                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/Devolutions/:id", component: DevolutionsDetaill },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/CreateDevolution", component: CreateDevolition },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/Devolutions", component: Devolutions },

                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/Categories/:idCategory", component: CategoryDetaill },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/Categories", component: CategoriesList },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/Presentations", component: Presentations },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/CreateWareHouse", component: CreateWarehouseAccount },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/WareHouseList", component: WareHouseList },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/WareHouseAdmin", component: WarehouseAdmin },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/UpdateWareHouse/:idWarehouse", component: UpdateWarehouse },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/CreateWinery", component: CreateWineryContainer },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/WineryList", component: WineryList },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/WineryAdmin", component: WineryAdmin },

                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/UpdateWinery/:idWinery", component: UpdateWinery },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/CreateSubWinery/:idWarehouse", component: CreateSubWineryContainer },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/SubWineriesList/:idWinery", component: SubWineriesList },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/UpdateSubWinery/:idSubWinery", component: UpdateSubWinery },

                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/Transfers", component: Transfers },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/TransferHistory", component: TransferHistory },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/transferDetaill/:id", component: TransferDetaill },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/CreateTranferWithoutOrder", component: CreateTranferWithoutOrder },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/PendingOrders", component: PendingOrders },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/OrderDetaill/:id", component: OrderDetaill },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/products/Create", component: ProducsCreate },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/products/:idProduct/Edit", component: ProductEdit },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/products", component: ProductList },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/ProductListById/:ProductsById", component: ProductsListById },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/productsHistory", component: ProductsItemMenuHistory },

                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/CreateConsignment/Cart", component: CartConsignment },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/CreateConsignment", component: CreateConsignment },

                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/batches", component: WineryBatches },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory/BatchesList/:ProductId/:LocationId", component: BatchesList },
                    { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Inventory", component: PrincipalInventoryMenu },


                ]
            },

            /*     { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/AwardsAdmin", component: AwardsAdmin }, */

            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Advertising/:idAdd", component: EditAdvertising },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Advertisings", component: ListAdvertising },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/CreateAdvertising", component: CreateAdvertising },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Job/:idJob", component: EditJob },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Jobs", component: LitsJobs },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/CreateJob", component: CreateJob },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ListZones", component: ListZones },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/CreateZone", component: CreateZoneView },


            /*             { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ClassifiedCategoriesAdmin", component: ClassifiedCategoriesAdmin },
                        { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ClassifiedSubcategoriesAdmin", component: ClassifiedSubcategoriesAdmin },
                        { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ClassifiedStatusAdmin", component: ClassifiedStatusAdmin },
                        { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/SkillCategoryAdmin", component: SkillCategoryAdmin }, */
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/PQRSAdmin", component: PQRSAdmin },
            { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ReactionAdmin", component: ReactionAdmin },
            /*  { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/ColorsReactionsAdmin", component: ColorsReactionsAdmin },
             { isPrivate: true, isExact: true, type: 'admin', path: "/Admin/Test/2", component: WareHouseList }, */

        ]
    },

    {
        isPrivate: true, isExact: false, path: "/Inventory", component: RootUser,
        routes: [
            ,
            { isPrivate: true, isExact: true, path: "/Test/2", component: StoriesBarNew },
            { isPrivate: true, isExact: true, path: "/Inventory/ReportByType", component: ReportByType },
            { isPrivate: true, isExact: true, path: "/Inventory/Utility", component: Utility },
            { isPrivate: true, isExact: true, path: "/Inventory/Sales", component: InventorySales },
            { isPrivate: true, isExact: true, path: "/Inventory/Inventory", component: InventoryList },
            { isPrivate: true, isExact: true, path: "/Inventory/Sale/:id", component: InventorySaleDetaill },
            { isPrivate: true, isExact: true, path: "/Inventory/SaleRegister/Cart", component: InventorySaleCart },

            { isPrivate: true, isExact: true, path: "/Inventory/SaleRegister", component: InventoryListForSale },




            { isPrivate: true, isExact: true, path: "/Inventory/", component: InventoryOptions },

        ]
    },


    !localStorage().getItem("statusLog") && { isPrivate: "both", isExact: true, path: "/payment/success", component: SuccessPayment },
    !localStorage().getItem("statusLog") && { isPrivate: "both", isExact: true, path: "/payment/pending", component: PendingPayment },
    !localStorage().getItem("statusLog") && { isPrivate: "both", isExact: true, path: "/payment/failed", component: FailedPayment },
    !localStorage().getItem("statusLog") && { isPrivate: "both", isExact: true, path: "/TermsAndConditions", component: TermsAndConditions },
    !localStorage().getItem("statusLog") && { isPrivate: "both", isExact: true, path: "/PrivacyTerms", component: Privacy },

    {
        isPrivate: true, isExact: false, path: "/", component: RootUser, typeUser: 'user',
        routes: [
            { isPrivate: true, isExact: true, path: "/testFetch", component: TestFetch },
            { isPrivate: true, isExact: true, path: "/testError", component: TestError },
            { isPrivate: true, isExact: true, path: "/test", component: CreateStream },
            { isPrivate: true, isExact: true, path: "/OilCounter", component: OilCounter },
            { isPrivate: true, isExact: true, path: "/PaymentTest", component: PaymentTest },

            localStorage().getItem("statusLog") && { isPrivate: "both", isExact: true, path: "/payment/success", component: SuccessPayment },
            localStorage().getItem("statusLog") && { isPrivate: "both", isExact: true, path: "/payment/pending", component: PendingPayment },
            localStorage().getItem("statusLog") && { isPrivate: "both", isExact: true, path: "/payment/failed", component: FailedPayment },
            localStorage().getItem("statusLog") && { isPrivate: "both", isExact: true, path: "/TermsAndConditions", component: TermsAndConditions },
            localStorage().getItem("statusLog") && { isPrivate: "both", isExact: true, path: "/PrivacyTerms", component: Privacy },
            { isPrivate: true, isExact: true, path: "/Stream/:idStream", component: ViewStream },

            { isPrivate: true, isExact: true, path: "/CreateFranchisee", component: CreateFranchisee },
            { isPrivate: true, isExact: true, path: "/EditFranchisee", component: EditFranchisee },
            { isPrivate: true, isExact: true, path: "/CreateRepresentative", component: CreateRepresentative },
            { isPrivate: true, isExact: true, path: "/Post/:postID", component: Post },
            { isPrivate: true, isExact: true, path: "/UserPQRS", component: CreatePqrs },
            { isPrivate: true, isExact: true, path: "/ResetPassword", component: ResetPassword },

            { isPrivate: true, isExact: true, path: "/PersonalInfo", component: EditUser },
            { isPrivate: true, isExact: true, path: "/BlockedFriendList", component: BlockedFriendList },
            { isPrivate: true, isExact: true, path: "/Messages/Admin", component: MessagesAdmin },
            { isPrivate: true, isExact: true, path: "/Messages", component: Chat },
            //{ isPrivate: true, isExact: true, path: "/Chat", component: Chat },
            { isPrivate: true, isExact: true, path: "/FollowingList/:userID", component: FollowingList },
            { isPrivate: true, isExact: true, path: "/FollowersList/:userID", component: FollowersList },

            { isPrivate: true, isExact: true, path: "/CertificateAccount", component: CertificateAccount },
            { isPrivate: true, isExact: true, path: "/CertificateAccountData", component: CertificateAccountData },
            { isPrivate: true, isExact: true, path: "/RankingUser", component: RankingUser },







            { isPrivate: true, isExact: true, path: "/Zones/Post/:zonePostID", component: Post, isPostZone: true },
            {
                isPrivate: true, isExact: false, path: "/Zones/Zone/:zoneId", component: Zone, routes: [
                    { isPrivate: true, isExact: true, path: "/Zones/Zone/:zoneId/Members", component: ZoneMembers },

                    { isPrivate: true, isExact: true, path: "/Zones/Zone/:zoneId", component: ZonePost },

                ]
            },
            {
                isPrivate: true, isExact: false, path: "/Zones/Admin/:zoneId", component: ZoneAdminRoot, routes: [
                    { isPrivate: true, isExact: true, path: "/Zones/Admin/:zoneId/Members", component: ZoneMembers },
                    { isPrivate: true, isExact: true, path: "/Zones/Admin/:zoneId/AddMember", component: AdminAddMember },
                    { isPrivate: true, isExact: true, path: "/Zones/Admin/:zoneId/Invite", component: AdminInviteZone },
                    { isPrivate: true, isExact: true, path: "/Zones/Admin/:zoneId/Requests", component: ZoneRequest },
                    { isPrivate: true, isExact: true, path: "/Zones/Admin/:zoneId/Reports", component: AdminReportsZone },
                    { isPrivate: true, isExact: true, path: "/Zones/Admin/:zoneId", component: AdminEditZone },
                ]
            },
            { isPrivate: true, isExact: true, path: "/Zones", component: Zones },

            { isPrivate: true, isExact: true, path: "/MarketPlace/Product/:productId", component: ProductDetaill },
            { isPrivate: true, isExact: true, path: "/MarketPlace/Points", component: MarketPlacePoints },
            { isPrivate: true, isExact: true, path: "/MarketPlace/Purchases/:purchaseId", component: PurchasesDetail },
            { isPrivate: true, isExact: true, path: "/MarketPlace/Purchases", component: Purchaseslist },

            { isPrivate: true, isExact: true, path: "/Devolutions", component: DevolutionByUserView },
            { isPrivate: true, isExact: true, path: "/MarketPlace", component: MarketPlace },

            { isPrivate: true, isExact: true, path: "/ShoppingBag/Points", component: ShoppingBagPoins },
            { isPrivate: true, isExact: true, path: "/ShoppingBag", component: ShoppingBag },
            { isPrivate: true, isExact: true, path: "/HowEcoTienda", component: HowEcoTienda },

            {
                isPrivate: true, isExact: false, path: "/Profile/:userID", component: Profile, routes: [
                    { isPrivate: true, isExact: true, path: "/Profile/:userID/MyAwards", component: SeeMyChallenges, },
                    { isPrivate: true, isExact: true, path: "/Profile/:userID/MyAlbums", component: Albums, },
                    { isPrivate: true, isExact: true, path: "/Profile/:userID/Album/:albumID", component: Album },
                    { isPrivate: true, isExact: true, path: "/Profile/:userID/MySaved", component: MySaved },
                    { isPrivate: true, isExact: true, path: "/Profile/:userID/Followers", component: SocialList },
                    { isPrivate: true, isExact: true, path: "/Profile/:userID/FriendList", component: FriendList },
                    { isPrivate: true, isExact: true, path: "/Profile/:userID/Followed", component: SocialList },
                    { isPrivate: true, isExact: true, path: "/Profile/:userID/Campaigns/:postId", component: Campaigns },
                    { isPrivate: true, isExact: true, path: "/Profile/:userID/Campaigns/", component: CampaignsList },
                    { isPrivate: true, isExact: true, path: "/Profile/:userID/PostCampaigns", component: PostCampaigns },
                    { isPrivate: true, isExact: true, path: "/Profile/:userID", component: MyPost },
                ]
            },

            {
                isPrivate: true, isExact: false, path: "/Franchise/:userID", component: ProfileFranchise, routes: [

                    { isPrivate: true, isExact: true, path: "/Franchise/:userID/Followed", component: SocialList },
                    { isPrivate: true, isExact: true, path: "/Franchise/:userID/Followers", component: SocialList },
                    { isPrivate: true, isExact: true, path: "/Franchise/:userID/Campaigns/:postId", component: Campaigns },
                    { isPrivate: true, isExact: true, path: "/Franchise/:userID/Campaigns/", component: CampaignsList },
                    { isPrivate: true, isExact: true, path: "/Franchise/:userID/PostCampaigns", component: PostCampaigns },
                    { isPrivate: true, isExact: true, path: "/Franchise/:userID", component: CampaignsList },
                ]
            },

            { isPrivate: true, isExact: true, path: "/OilMenu", component: OilMenu },
            { isPrivate: true, isExact: true, path: "/Oil/OilRegister", component: OilRegister },
            { isPrivate: true, isExact: true, path: "/Oil/OilRecordEcoCEO", component: OilRecordEcoCEO },
            { isPrivate: true, isExact: true, path: "/Oil/OilRecordEcoUser", component: OilRecordEcoUser },
            // { isPrivate: true, isExact: true, path: "/Oil/OilRecordWarehouses", component: OilRecordWarehouses },

            {
                isPrivate: true, isExact: false, path: "/Rooms/", component: RootRoom,
                routes: [
                    { isPrivate: true, isExact: true, path: "/Rooms/NewRoom", component: CreateRoom },



                    { isPrivate: true, isExact: true, path: "/Rooms/SeeRoomsBySearch", component: SeeRoomsBySearch },
                    { isPrivate: true, isExact: true, path: "/Rooms/Room/:idRoom", component: RootOneRoom },

                    {
                        isPrivate: true, isExact: false, path: "/Rooms/Admin/:idRoom", component: RootAdminRoom,
                        routes: [
                            { isPrivate: true, isExact: true, path: "/Rooms/Admin/:idRoom/Members", component: AdminRoomMembers },
                            { isPrivate: true, isExact: true, path: "/Rooms/Admin/:idRoom/Invite", component: AdminInviteRoom },
                            { isPrivate: true, isExact: true, path: "/Rooms/Admin/:idRoom/Requests", component: AdminRequestRoom },
                            { isPrivate: true, isExact: true, path: "/Rooms/Admin/:idRoom/Reports", component: AdminReportsRoom },
                            { isPrivate: true, isExact: true, path: "/Rooms/Admin/:idRoom/Delete", component: AdminDeleteRoom },
                            { isPrivate: true, isExact: true, path: "/Rooms/Admin/:idRoom", component: EditRoom },

                        ]
                    },
                    {
                        isPrivate: true, isExact: false, path: "/Rooms/", component: ListRooms,
                        routes: [
                            { isPrivate: true, isExact: true, path: "/Rooms/Category/:categoryName", component: SeeAllRooms },

                            { isPrivate: true, isExact: true, path: "/Rooms/join/:idRoom", component: Join },
                            { isPrivate: true, isExact: true, path: "/Rooms/", component: MessageRooms },
                        ]
                    },
                ]
            },
            { isPrivate: true, isExact: true, path: "/", component: HomePost }

        ]
    },


].filter(opt => typeof opt != "boolean")



export function RouteWithSubRoutes(route) {
    return <Route
        exact={route.isExact}
        path={route.path}
        render={props => {
            if (route.type === 'admin')
                if (localStorage().getItem("typeUser") === 'admin')
                    return (route.isPrivate ?
                        localStorage().getItem("statusLog") ?
                            <route.component {...props} routes={route.routes} />
                            :
                            <Redirect to="/Login" />
                        :
                        !localStorage().getItem("statusLog") ?
                            <route.component {...props} routes={route.routes} />
                            :
                            <Redirect to="/" />
                    )
                else
                    return (route.isPrivate ?
                        localStorage().getItem("statusLog") ?
                            <Redirect to="/" />
                            :
                            <Redirect to="/Login" />
                        :
                        !localStorage().getItem("statusLog") ?
                            <Redirect to="/" />
                            :
                            <Redirect to="/" />
                    )
            else
                if (localStorage().getItem("typeUser") === 'admin')
                    return (route.isPrivate &&
                        <Redirect to="/Admin" />
                    )
                else if (route.isPrivate === "both") {

                    return <route.component {...props} routes={route.routes} />
                }
                else {


                    return (route.isPrivate === true ?
                        localStorage().getItem("statusLog") ?
                            <route.component {...props} routes={route.routes} />
                            :
                            <Redirect to="/Login" />
                        :
                        !localStorage().getItem("statusLog") ?
                            <route.component {...props} routes={route.routes} />
                            :
                            <Redirect to="/" />
                    )
                }
        }
        }
    />
}